import createApi from 'api/createApi';

export const tags = {
	auth: 'sn/CallEvent/auth',
};

export const callEventApi = createApi({
	reducerPath: 'sn/callEventApi',

	endpoints: (builder) => ({
		auth: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/sn/CallEvent/auth',
				body,
				jsonType: true,
			}),
			providesTags: [tags.auth],
		}),
	}),
});

export const {
	auth,
} = callEventApi.endpoints;

export default callEventApi;